module.exports = __webpack_public_path__ + "img/5-2.af8e2a26.svg";